<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<section class="dashboard_container">
  <div class="container-fluid">
    <div class="row no-pad mar-btm-40">
      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 1 ">
        <div class="dashboard_cards" routerLink="/newParts" id="newPartsBlock">
          <div class="card_title text-center">
            {{'NEWPARTS' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/new-parts-dashboard-Icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{newPartsCount}}
          </div> -->
        </div>
      </div>
      
      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 1 ||adminAccess == 2 ||adminAccess == 3 ||adminAccess == 4 ||adminAccess == 5 || adminAccess == 7 || adminAccess == 9 || adminAccess == 15">
        <div class="dashboard_cards" routerLink="/partStatus" id="partsStatusBlock">
          <div class="card_title text-center">
            {{ 'PARTSTATUS' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/part-status-dashboard-icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{partStatusCount}}
          </div> -->
        </div>
      </div>
      <div class="col-md-3" *ngIf="adminAccess == 1  || adminAccess == 3 || adminAccess == 4 || adminAccess == 7">
        <div class="dashboard_cards" [routerLink]="['/packageRevision']" id="pkgRevisionBlock">
          <div class="card_title text-center">
            {{'PACKAGEREVISION' | translate}}
          </div>

          <div class="card_icon text-center">
            <img src="../../../assets/package-revision-dashboard-icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{packageRevisionCount}}
          </div> -->
        </div>
      </div>
      <div class="col-md-3" *ngIf="adminAccess == 1 ||adminAccess == 2 ||adminAccess == 3||adminAccess == 4 || adminAccess == 7">
        <div class="dashboard_cards" [routerLink]="['/packageDashboard/package']" id="newPackageBlock">
          <div class="card_title text-center">
            {{'NEWPACKAGE' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/new-package-dashboard-icon.png">
          </div>
        </div>
      </div>
      <div class="col-md-3" *ngIf="adminAccess == 5 ||adminAccess == 9">
        <div class="dashboard_cards" [routerLink]="['/packageDashboard/package']" id="newPackageBlock">
          <div class="card_title text-center">
            {{'EDIT PACKAGE CODE' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/new-package-dashboard-icon.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 1 ||adminAccess == 2 || adminAccess == 3 ||adminAccess == 4  || adminAccess == 7 || adminAccess == 11">
        <div class="dashboard_cards" routerLink="/todo" id="toDoBlock">
          <div class="card_title text-center">
            {{'TODO' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/to-do-dashboard-icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{todoCount}}
          </div> -->
        </div>
      </div>
      <div class="col-md-3" *ngIf="adminAccess == 1 ||adminAccess == 2 || adminAccess == 3 ||adminAccess == 4 || adminAccess == 7">
        <div class="dashboard_cards" routerLink="/notification" id="notificationBlock">
          <div class="card_title text-center">
            {{'NOTIFICATION' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/notification-dashboard-icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{notificationCount}}
          </div> -->
        </div>
      </div>
      <!-- <div class="col-md-3" *ngIf="adminAccess == 2 || adminAccess == 3 ||adminAccess == 5 || adminAccess == 7">
        <div class="dashboard_cards" routerLink="/kpi" id="kpiBlock">
          <div class="card_title text-center">
            KPI
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/kpi-dashboard-icon.png">
          </div>
        </div>
      </div> -->

      <div class="col-md-3" *ngIf="adminAccess == 2 || adminAccess == 3 || adminAccess == 7">
        <div class="dashboard_cards" routerLink="/kpinew" id="kpiBlock">
          <div class="card_title text-center">
            KPI
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/kpi-dashboard-icon.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 8 ||adminAccess ==  9 ">
        <div class="dashboard_cards" routerLink="/um" id="userMgtBlock">
          <div class="card_title text-center">
            {{'USER MANAGEMENT' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/usermanagement-icon.png">
          </div>
        </div>
      </div>
      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 8 || adminAccess == 9 ">
        <div class="dashboard_cards" routerLink="/adminSupplierCode">
          <div class="card_title text-center">
            {{'SupplierCodeDashboard' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/supplier-code-icon.png">
          </div>
        </div>
      </div>
      <div class="col-md-3" *ngIf="adminAccess == 5 || adminAccess == 8 || adminAccess == 9">
        <div class="dashboard_cards" routerLink="/supplierManagement" id="splrMgtBlock">
          <div class="card_title text-center">
            {{'SUPPLIER CODE MAPPING' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/supplier-mgmnt-icon.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 ||adminAccess == 8 ||adminAccess == 9 ">
        <div class="dashboard_cards" routerLink="/supplierDatabase" id="splrDatabase">
          <div class="card_title text-center">
            {{'SUPPLIER PARTS DATABASE' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/Supp-Parts-Database.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 ||adminAccess == 8 ||adminAccess == 9 ">
        <div class="dashboard_cards" routerLink="/supplieradressDatabase" id="splrDatabaseAdress">
          <div class="card_title text-center">
            {{'SUPPLIER ADDRESS DATABASE' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/Supp-Parts-Address.png">
          </div>
        </div>
      </div>
      <!-- <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 9">
        <div class="dashboard_cards" routerLink="/groupNo" id="grpNumber">
          <div class="card_title text-center">
            GROUP NUMBER
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/group-number-icon.png">
          </div>
        </div>
      </div> -->
      <!-- <li class="register_link" *ngIf="adminAccess == 5 || adminAccess == 9">
        <a href="#" routerLink="/groupNo">GROUP NUMBER</a>
      </li> -->
      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 8">
        <div class="dashboard_cards" routerLink="/vendorScheduler" id="splrMgtBlock">
          <div class="card_title text-center">
            {{'VENDOR SCHEDULER' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/VS-code-icon.png">
          </div>
        </div>
      </div>
      <div class="col-md-3" *ngIf="adminAccess == 5 || adminAccess == 8 || adminAccess == 9">
        <div class="dashboard_cards" routerLink="/register" id="registerBlock">
          <div class="card_title text-center">
            {{'REGISTER' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/add-new-user.png">
          </div>
        </div>
      </div>

      <div class="col-md-3" *ngIf="adminAccess == 5 || adminAccess == 9">
        <div class="dashboard_cards" routerLink="/deliveryPoint" id="locationBlock">
          <div class="card_title text-center">
            {{'Delivery_Point_Dashboard' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/location-point.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 4 || adminAccess == 9">
        <div class="dashboard_cards" routerLink="/lineNumber" id="lineNumber">
          <div class="card_title text-center">
            {{'NEXT PROCESS' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/line-number-icon.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 10 || adminAccess == 9 || adminAccess == 3 || adminAccess == 8 || adminAccess == 4">
        <div class="dashboard_cards" routerLink="/downloadData" id="downloadData">
          <div class="card_title text-center">
            DOWNLOAD
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/vol_fc.png">
          </div>
        </div>
      </div>


      
        <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 10 || adminAccess == 9 || adminAccess == 3 || adminAccess == 8">
        <div class="dashboard_cards" routerLink="/uploadData" id="uploadData">
          <div class="card_title text-center">
            Upload
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/vol_fc.png">
          </div>
        </div>
      </div>
      

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 16">

        <div class="dashboard_cards" routerLink="/rackUpload" id="downloadData">
          <div class="card_title text-center">
              {{'Rack Upload' | translate}}
          </div>
          <div class="pfepIcons text-center">
            <img src="../../../assets/rackUpload.svg">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 16">

        <div class="dashboard_cards" routerLink="/noubaUpload" id="downloadData">
          <div class="card_title text-center">
              {{'Nouba Upload' | translate}}
          </div>
          <div class="pfepIcons text-center">
            <img src="../../../assets/noubaUpload.svg">
          </div>
        </div>
      </div>

      <!-- <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 16">
        <div class="dashboard_cards" routerLink="/downloadData" id="downloadData">
          <div class="card_title text-center">
           {{'Supplier Info Upload' | translate}}
          </div>
          <div  class="pfepIcons text-center">
            <img src="../../../assets/supplierInfoUpload.svg">
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 16">
        <div class="dashboard_cards" routerLink="/downloadData" id="downloadData">
          <div class="card_title text-center">
            {{'Jikoutei' | translate}}
          </div>
          <div class="pfepIcons text-center">
            <img src="../../../assets/jikoutei.svg">
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 16">
        <div class="dashboard_cards" routerLink="/downloadData" id="downloadData">
          <div class="card_title text-center">
          {{'Transportation Mode' | translate}}
          </div>
          <div class="pfepIcons text-center">
            <img src="../../../assets/transportationMode.svg">
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 16">
        <div class="dashboard_cards" routerLink="/downloadData" id="downloadData">
          <div class="card_title text-center">
              {{'Nouba per building' | translate}}
          </div>
          <div class="pfepIcons text-center">
            <img src="../../../assets/noubaPerBuilding.svg">
          </div>
        </div>
      </div> -->
        

      <!--
        <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 16">
        <div class="dashboard_cards" routerLink="/downloadData" id="downloadData">
          <div class="card_title text-center">
              {{'Pfep View and Search' | translate}}
          </div>
          <div class="pfepIcons text-center">
            <img src="../../../assets/pfepViewsearch.svg">
          </div>
        </div>
      </div>
      -->

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 10">
        <div class="dashboard_cards" [routerLink]="['/processCode']" id="processCode">
          <div class="card_title text-center">
            {{'SUPPLY_PROCESS_CODE' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/process-code.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40"  *ngIf="adminAccess == 5">
        <div class="dashboard_cards" routerLink="/configuration" id="suppliertosupplierdelivery">
          <div class="card_title text-center">
            Supplier To Supplier Delivery Config
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/process-code.png">
          </div>
        </div>
      </div>

      <!-- <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 12">
        <div class="dashboard_cards" routerLink="/monthlyviewsupplier" id="monthlyView">
          <div class="card_title text-center">
            SUPPLIER MONTHLY VIEW
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/supplier-montly-view.png">
          </div>
        </div>
      </div>
      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 12">
        <div class="dashboard_cards" routerLink="/weeklyviewsupplier" id="weeklyView">
          <div class="card_title text-center">
            SUPPLIER WEEKLY VIEW
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/supplier-weekly-view.png">
          </div>
        </div>
      </div> -->

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 12">
        <div class="dashboard_cards" routerLink="/L4-kpi" id="L4KPI">
          <div class="card_title text-center">
            {{'L4 Manager KPI' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/L4KPI.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 3 || adminAccess == 13">
        <div class="dashboard_cards" routerLink="/poDashboard" id="prefecData">
          <div class="card_title text-center">
            {{'VOLUME DATA' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/vol_data.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 9 || adminAccess == 5">
        <div class="dashboard_cards" routerLink="/prefectures" id="volData">
          <div class="card_title text-center">
            {{'PREFECTURES' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/vol_data.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5">
        <div class="dashboard_cards" routerLink="/spcConfig" id="spcConfig">
          <div class="card_title text-center">
            {{'SPC EXCEPTION' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/L4KPI.png">
          </div>
        </div>
      </div>

      <!-- <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5">
        <div class="dashboard_cards" routerLink="/spcConfig" id="spcConfig">
          <div class="card_title text-center">
            {{'SPC EXCEPTION' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/L4KPI.png">
          </div>
        </div>
      </div> -->

      <div class="col-md-3 mar-btm-40" *ngIf="adminAccess == 5 || adminAccess == 9">
        <div class="dashboard_cards" routerLink="/serPro" id="serviceProvider">
          <div class="card_title text-center">
            {{'SERVICE PROVIDER'}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/new-parts-dashboard-Icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{newPartsCount}}
          </div> -->
        </div>
      </div>

    </div>
  </div>
</section>